/**
 * Resolve chart.js axis/grid/legend colors from the active theme at render time.
 *
 * In this fork dark mode is applied as the `dark` class on document.body
 * (see dashboard/helper/themeHelper.js). Reading it here keeps the Kanban
 * report charts legible in BOTH light and dark, instead of the previous
 * dark-only fixed slate hexes (#64748b tick + ~10% slate grid that vanished
 * on a white background).
 *
 * These are plain JS color strings consumed by chart.js (canvas config),
 * NOT Tailwind classes, so they are unaffected by the JIT/@apply caveat.
 */
export const getChartThemeColors = () => {
  const isDark =
    typeof document !== 'undefined' &&
    document.body.classList.contains('dark');

  if (isDark) {
    return {
      tick: '#94a3b8', // slate-400 — readable on dark surface
      legend: '#94a3b8',
      grid: 'rgba(148, 163, 184, 0.18)',
    };
  }

  return {
    tick: '#475569', // slate-600 — strong contrast on white
    legend: '#475569',
    grid: 'rgba(100, 116, 139, 0.18)',
  };
};
